import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useOnboardingCheck } from '@/hooks/useOnboardingCheck';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

function RootRedirect() {
  const { user, loading: authLoading } = useAuth();
  const { needsOnboarding, loading: onboardingLoading } = useOnboardingCheck();
  const [timeoutReached, setTimeoutReached] = useState(false);

  // 3-second timeout guard against infinite loading
  useEffect(() => {
    const timer = setTimeout(() => {
      if (authLoading || onboardingLoading) {
        console.warn('RootRedirect timeout - forcing redirect');
        setTimeoutReached(true);
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [authLoading, onboardingLoading]);


  // Timeout fallback - redirect to login if loading fails
  if (timeoutReached) {
    console.warn('Timeout reached, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (authLoading || onboardingLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 via-background to-secondary/10">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Not logged in -> login page
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Logged in but needs onboarding
  if (needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }

  // Logged in and onboarded -> redirect to home
  return <Navigate to="/home" replace />;
}

export default RootRedirect;
